import React from 'react';
import { Card, Space, Skeleton, Empty, Button, Tooltip } from 'antd';
import { Line } from 'react-chartjs-2';
import { LineChartOutlined, DownloadOutlined } from '@ant-design/icons';

const MonthlyEvolution = ({ data, chartOptions, loading, onExport }) => {
  return (
    <Card
      title={
        <Space>
          <LineChartOutlined style={{ color: '#8b5cf6', fontSize: 18 }} />
          <span style={{ fontWeight: 800 }}>Evolução de Conciliação Mensal</span>
        </Space>
      }
      extra={
        onExport && (
          <Tooltip title="Exportar evolução mensal">
            <Button 
              type="text" 
              icon={<DownloadOutlined style={{ fontSize: 16 }} />} 
              onClick={onExport}
              style={{ color: '#64748b' }}
            />
          </Tooltip>
        )
      }
      bordered={false}
      style={{ borderRadius: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', height: 480 }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : !data || !data.datasets ? (
        <div style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description="Dados de evolução indisponíveis" />
        </div>
      ) : (
        <div style={{ height: 380, position: 'relative' }}>
          <Line 
            data={data}
            options={{
              ...chartOptions,
              plugins: {
                ...chartOptions.plugins,
                legend: { ...chartOptions.plugins.legend, position: 'top' }
              },
              elements: {
                line: { tension: 0.4 } // makes the line curvy
              }
            }}
          />
        </div>
      )}
    </Card>
  );
};

export default MonthlyEvolution;

